export const MANUAL_STATES = {
  pending: "pending",
  accepted: "accepted",
  rejected: "rejected",
};
